import React from "react";
import ReactDOM from "react-dom";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import ModalBase from "./ModalBase";
import ChooseGenerateType from "../forms/ChooseGenerateType";
import DocService from "../export/DocService";
import ReportFile from "../report/ReportFile";

import "../../../assets/sass/components/modals/generate-report-modal.scss";

import ReportExcelTable from "../report/ReportExcelTable";
import ComparePlansModal from "../plans/ComparePlansModal";
import { Link } from "react-router-dom";

class GenerateReportModal extends ModalBase {
    constructor(props) {
        super(props)

        this.state = {
            generateType: 'pdf',
            styleType: 'default',
            isLoading: false,
            downloadsRemaining: 2,
            showPlansModal: false
        }
    }


    renderBody = () => {
        return (
            <>
                <p className="text">Report Template</p>
                {this.renderForm()}
                <p className="text">Select Report Format to be Generated</p>
                {this.renderChooseGenerateType()}
                {this.renderReports()}
            </>
        )
    };

    renderHeader = () => {
        const { headerTitle, headerSubtitle } = this.props;

        return (
            <React.Fragment>
                <Modal.Title className="title">{headerTitle}</Modal.Title>
                <Modal.Title className="subtitle">{headerSubtitle}</Modal.Title>
            </React.Fragment>
        );
    };

    renderFooter = () => {
        const { isLoading, downloadsRemaining } = this.state;

        return (
            <>
                {this.renderUpgradeMessage()}
                {!downloadsRemaining ?
                <Link to="/pricing" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg btn-block">Upgrade Account</Link>
                : <Button
                    variant="primary"
                    block
                    size="lg"
                    disabled={isLoading}
                    onClick={() => this.handleGenerateReportSubmit()}
                >{isLoading ? 'Generating...' : 'Generate and Download Report'}</Button>}
                <Button
                    variant="secondary"
                    block
                    size="lg"
                    onClick={() => this.props.onHide()}
                >Cancel</Button>
            </>
        )
    }

    renderUpgradeMessage = () => {
        const { downloadsRemaining, showPlansModal } = this.state;

        return (
            <div className="upgrade-message">
                <span className="upgrade-message--text">{downloadsRemaining} downloads remaining</span>
                {/* <Button variant="link" className="upgrade-message--btn" onClick={() => this.setState({ showPlansModal: true })}>Upgrade Account</Button> */}
                <ComparePlansModal show={showPlansModal} onHide={() => this.setState({ showPlansModal: false })} />
            </div>
        )
    }

    renderForm = () => {
        const { styleType } = this.state;

        return (
            <Form.Group>
                <Row>
                    <Col md={4} sm={6}>
                        <Form.Check
                            name="template"
                            custom
                            type="radio"
                            label="Default"
                            id="default-template"
                            onChange={(e) => this.handleStyleTypeChange(e, 'default')}
                            checked={styleType === 'default'}
                        />
                    </Col>
                    <Col md={4} sm={6}>
                        <Form.Check
                            name="template"
                            custom
                            type="radio"
                            label="Compact"
                            id="compact-template"
                            onChange={(e) => this.handleStyleTypeChange(e, 'compact')}
                            checked={styleType === 'compact'}
                        />
                    </Col>
                </Row>
            </Form.Group>
        )
    }

    renderChooseGenerateType = () => {
        const { generateType } = this.state;

        return (
            <ChooseGenerateType types={['pdf', 'jpg', 'csv', 'xls']} onChange={this.handleGenerateTypeChange} defaultType={generateType} />
        )
    }

    renderReports = () => {
        const { generateType, styleType } = this.state;
        switch(generateType) {
            case 'pdf':
            case 'jpg':
                return (
                    <div className="theme--default" id="export-file">
                        <ReportFile ref="scoutingReport" styleType={styleType}/>
                    </div>
                )
            case 'xls':
            case 'csv':
                return (
                    <div className="theme--default" id="export-file">
                        <ReportExcelTable />
                    </div>
                )
            default:
                return null
        }
    }

    /**
     * handlers
     */

    handleGenerateTypeChange = fileType => {
        this.setState({
            generateType: fileType
        })
    }

    handleStyleTypeChange = (event, styleType) => {
        const isChecked = event.target.checked;
        
        if(isChecked) {
            this.setState({
                styleType
            })
        }
    }

    handleGenerateReportSubmit = () => {
        const { generateType } = this.state;
        
        this.setIsLoading(true, () => {
            setTimeout(() => {
                if(generateType === 'pdf') this.downloadPDFFile();
                else if(generateType === 'jpg') this.downloadPNGFile();
                else if(generateType === 'xls') this.downloadExcelFile();
                else if(generateType === 'csv') this.downloadCsvFile();
                else console.warn('Select generate type.')
            }, 10)
        });
    }

    onGenerateEnd = () => {
        this.setState(prevState => ({ isLoading: false, downloadsRemaining: prevState.downloadsRemaining - 1 }));
    }

    setIsLoading = (loading, callback = console.log) => {
        this.setState({ isLoading: loading }, callback);
    }

    /**
     * Generate functions
     */

    downloadPDFFile = () => {
        DocService.exportPdf(this.reportNode(), this.exportedFileName(), this.onGenerateEnd);
    };

    downloadPNGFile = () => {
        DocService.exportJpg(this.reportNode(), this.exportedFileName(), this.onGenerateEnd);
    };

    downloadExcelFile = () => {
        DocService.exportSheet('report-excel-table', this.exportedFileName(), false, this.onGenerateEnd);
    };

    downloadCsvFile = () => {
        DocService.exportSheet('report-excel-table', this.exportedFileName(), true, this.onGenerateEnd);
    };

    reportNode = () => ReactDOM.findDOMNode(this.reportRef());
    reportRef = () => this.refs.scoutingReport;
    exportedFileName = () => 'Scouting Report';

    modalClassname = () => "generate-report-modal";

    static defaultProps = {
        ...super.defaultProps,
        size: "md-sm",
        headerTitle: "Generate and Download Report",
        headerSubtitle: "Select report template and report file format",
    };
}

export default GenerateReportModal;
